<div edsGrid [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-password-access-document"
    folderTemplateQuery="new-password-access-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <!-- Static Password Access -->
</div>
<!-- Just for Bloomreach isEditMode -->
<div *ngIf="isEditMode" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Static Password Access</strong>
    </div>
  </div>
</div>
